import { useEffect } from "react";
import { Nav } from "@/components/site/Nav";
import { Hero, Disciplinas } from "@/components/site/Hero";
import { Galeria } from "@/components/site/Galeria";
import { Programa, VideoApoyemos } from "@/components/site/Programa";
import { Trabajo, Actividades } from "@/components/site/Trabajo";
import { Mapa, Fundador } from "@/components/site/Mapa";
import { Juegos } from "@/components/site/Juegos";
import { Redes } from "@/components/site/Redes";
import { Donar, Contacto, Footer } from "@/components/site/Donar";

function useSiteEffects() {
  useEffect(() => {
    document.querySelectorAll("video:not([data-lazyplay])").forEach((v) => {
      v.muted = true;
      const p = v.play && v.play();
      if (p && p.catch) p.catch(() => {});
      v.addEventListener("error", () => { v.style.display = "none"; }, true);
    });
    const els = document.querySelectorAll(".reveal");
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let io = null;
    if ("IntersectionObserver" in window && !reduce) {
      io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }), { threshold: 0.12 });
      els.forEach((el) => io.observe(el));
    } else {
      els.forEach((el) => el.classList.add("in"));
    }
    if (window.location.hash) {
      setTimeout(() => document.getElementById(window.location.hash.slice(1))?.scrollIntoView(), 80);
    }
    return () => io && io.disconnect();
  }, []);
}

export default function Home() {
  useSiteEffects();
  return (
    <div data-testid="home-page">
      <Nav />
      <Hero />
      <Disciplinas />
      <Programa />
      <VideoApoyemos />
      <Trabajo />
      <Actividades />
      <Mapa />
      <Fundador />
      <Juegos />
      <Redes />
      <Donar />
      <Galeria />
      <Contacto />
      <Footer />
    </div>
  );
}
